module.exports = __webpack_public_path__ + "static/media/about_banner@768.15833749.png";